import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import Arrows from '../../../../static/images/icons/slider-arrows.svg';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

export const Container = GridContainer;

export const Counter = styled.p`
    display: block;
    margin-top: 10px;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    color: ${COLORS.darkGrey};
    margin-right: 17px;
    line-height: 24px;
    text-align: center;
    @media(max-width: 919px){
        display:none;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    align-self: center;
`;

export const Section = styled.div`
    display: block;
    width: 100%;
    overflow: hidden;
`;

export const Title = styled.h1`
    margin: 70px 0 37px;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-size: 32px;
    line-height: 1.32;
    font-weight: 300;
    color: ${COLORS.black};
    @media (max-width: 860px) {
        margin: 90px 0 37px;
    }
    @media (max-width: 530px) {
        margin: 50px 0 37px;
        font-size: 24px;
    }
`;

export const DotWrapper = styled.div`
    align-self: center;
    margin: 0 auto -80px 20px;

`;

export const Dots = styled.div`
    display: none;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    text-align: center;
    background: ${props => props.active ? COLORS.lightBlue : COLORS.grey};
    opacity: ${props => props.active ? 1 : 0.6};
    padding: 5px;
    margin: 0 20px 0 0;
    cursor: pointer;
    &:hover{
        opacity: ${props => props.active ? 1 : 0.6};
        background: ${COLORS.blue}
    }

`;

export const ArrowWrapper = styled.div`
    width: calc(100% + 60px);
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: calc(50% - 15px);
    left: -30px;
    @media(max-width: 919px){
        display: none;
    }
`;

export const LeftArrow = styled.div`
    cursor: pointer;
    :before {
        display: flex;
        content:''!important;
        width: 21px;
        height: 36px;
        left: -7px;
        opacity: 1;
        background-image: url(${Arrows})!important;
        background-repeat: no-repeat;
        background-position: 0;
    }
`;

export const RightArrow = styled.div`
    cursor: pointer;
    :before {
        display: flex;
        content:''!important;
        margin-left:10px;
        width: 21px;
        height: 36px;
        left: 7px;
        opacity: 1;
        background-image: url(${Arrows})!important;
        background-repeat: no-repeat;
        background-position: -25px;
   }
`;

export const SliderWrapper = styled.div`
    overflow: visible;
    width: calc(100% + 20px);
    margin: 0 -10px;
    @media(max-width: 1279px) {
        width: calc(100% + 10px);
        margin: 0 -5px;
    }
    @media(max-width: 919px){
        max-width: 370px;
        margin-bottom: 48px;
    }
`;

export const Slide = styled.div`
    display: block;
    width: calc(100% - 20px);
    margin: 0 auto;
    max-width: 431px;
    @media(max-width: 1279px) {
        width: calc(100% - 10px);
    }
`;
